// import { OverlayLoader } from "../Loader/OverlayLoader";
import { CLASS_CONSTANTS } from "@/utils/constants";
import { HtmlOrSvgIcon } from "@/components/icons";
import { css } from "@linaria/core";
import clsx from "clsx";
import { RenderHtml } from "@/components/RenderHtml";

const { MESSAGE } = CLASS_CONSTANTS;

const attachmentAnchorClassName = css`
  display: flex;
  align-items: center;
  padding-inline-end: 1em;

  & + & {
    border-top: 2px solid #ccc;
  }

  .${MESSAGE.ROOT} & {
    background: var(--ws-message-attachment-bg);
    color: var(--ws-message-attachment-text);

    &:hover {
      background: var(
        --ws-message-attachment-hover-bg,
        var(--ws-message-attachment-bg)
      );
      color: var(
        --ws-message-attachment-hover-text,
        var(--ws-link-hover-color)
      );
      text-decoration: var(
        --ws-message-attachment-hover-decoration,
        var(--ws-link-hover-decoration)
      );
    }
  }
`;

const attachmentIconWrapperClassName = css`
  line-height: 1;
  padding: 0.5em;
  margin-right: 1em;
  background: var(--ws-message-attachment-icon-bg);
  color: inherit;
  width: 2.5em;
  align-self: stretch;
  display: flex;
  align-items: center;
  flex-grow: 0;
  flex-shrink: 0;
  svg {
    width: var(--ws-svg-attachment-icon-width, var(--ws-svg-icon-width, 24px));
    height: var(
      --ws-svg-attachment-icon-height,
      var(--ws-svg-icon-height, 24px)
    );
  }
`;

const attachmentNameClassName = css`
  padding: 5px 0;
  word-break: break-all;
`;

type AttachmentProps = {
  type: string;
  url: string;
  name: string;
};

export const Attachment = ({ type, url, name }: AttachmentProps) => {
  return (
    <a
      className={clsx(MESSAGE.ATTACHMENT, attachmentAnchorClassName)}
      href={url}
      rel="noopener noreferrer"
      target="_blank"
      title={name}
    >
      <span className={attachmentIconWrapperClassName}>
        <HtmlOrSvgIcon type={type} className={MESSAGE.ATTACHMENT_ICON} />
      </span>
      <span className={attachmentNameClassName}>
        <RenderHtml>{name}</RenderHtml>
      </span>
    </a>
  );
};
